import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREAUCT_Pre_Auction_Due_Diligence.css';

const PREAUCT_Pre_Auction_Due_Diligence = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREAUCT_PRE_AUCTION_DUE_DILIGENCE:-1
  });


  const [PREAUCT_PRE_AUCTION_DUE_DILIGENCE, setPREAUCT_PRE_AUCTION_DUE_DILIGENCE] = React.useState(null);
  const [PREAUCT_PRE_AUCTION_DUE_DILIGENCE_D, setPREAUCT_PRE_AUCTION_DUE_DILIGENCE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Due Diligence');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREAUCT_PRE_AUCTION_DUE_DILIGENCE(clientInfo,"OpenNew");

		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREAUCT_PRE_AUCTION_DUE_DILIGENCE(clientInfo,"OpenNew");
		}
		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
		if(Temp_Data2.status!="New"){
			handleDeletePREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data2);
			navigate('/PREAUCT_Pre_Auction_Due_Diligence#New',{replace:true});
		} 
		else 
			navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pre_Auction_Due_Diligence',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREAUCT_PRE_AUCTION_DUE_DILIGENCE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREAUCT_PRE_AUCTION_DUE_DILIGENCE]) ;


  
  
  var Ids = [];
  for(var Ele in PREAUCT_PRE_AUCTION_DUE_DILIGENCE){
	  for(var Sec in PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele]){
		if(Sec == "id")
			Ids.push(PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele]["status"]);
		else if(Array.isArray(PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele][Sec]))
			  for(var Row in PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele][Sec])  // Convert to PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREAUCT_PRE_AUCTION_DUE_DILIGENCE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREAUCT_PRE_AUCTION_DUE_DILIGENCE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREAUCT_PRE_AUCTION_DUE_DILIGENCE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE`).then((response1) => {
		if(!PREAUCT_PRE_AUCTION_DUE_DILIGENCE) 
			setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE_D`).then((response2) => {
			setPREAUCT_PRE_AUCTION_DUE_DILIGENCE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREAUCT_PRE_AUCTION_DUE_DILIGENCE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREAUCT_PRE_AUCTION_DUE_DILIGENCE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREAUCT_PRE_AUCTION_DUE_DILIGENCE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREAUCT_PRE_AUCTION_DUE_DILIGENCE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_PRE_AUCTION_DUE_DILIGENCE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2"]=value;
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2",value,Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
  }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3"]=value;
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3",value,Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
  }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0"]=value;
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1"]=value;
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2"]=value;
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  


const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  


    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4"]=value;
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4"]=value;
	//handleAddPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data,App_Data['PREAUCT_PRE_AUCTION_DUE_DILIGENCE']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
    setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREAUCT_PRE_AUCTION_DUE_DILIGENCE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE =JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
  updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE[Sec] = [...updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE[Sec], newRow];
  setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE = JSON.parse(JSON.stringify(PREAUCT_PRE_AUCTION_DUE_DILIGENCE));
  updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE[sec].splice(index, 1);
  setPREAUCT_PRE_AUCTION_DUE_DILIGENCE(updatedPREAUCT_PRE_AUCTION_DUE_DILIGENCE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Pre-Auction Due Diligence`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pre-Auction Due Diligence ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT DD ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0" type="text" className="form-control" placeholder="PREAUCT DD ID" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT DD ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Opportunity ID" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`DD Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2" type="date"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2`]} 
							onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2_Change} style={{ borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter DD Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`DD Target Completion Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3" type="date"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3`]} 
							onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3_Change} style={{ borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_1_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter DD Target Completion Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Title Defect Risk`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Title Defect Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_0_Change} className="form-control" name="Title Defect Risk"  >
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Title Defect Risk
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Hidden Lien Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_1_Change} className="form-control" name="Hidden Lien Risk"  >
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Hidden Lien Risk
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Tax Delinquency Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_2_Change} className="form-control" name="Tax Delinquency Risk"  >
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Tax Delinquency Risk
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Redemption Period Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_2_3_Change} className="form-control" name="Redemption Period Risk"  >
						  <option value="None">None</option>
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Redemption Period Risk
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Eviction Risk`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Eviction Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["3"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_0_Change} className="form-control" name="Eviction Risk"  >
						  <option value="None">None</option>
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Eviction Risk
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Repair Risk`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["3"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_1_Change} className="form-control" name="Repair Risk"  >
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Repair Risk
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Market Risk Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["3"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_3_2_Change} className="form-control" name="Market Risk Level"  >
						  <option value="Low">Low</option>
						  <option value="Medium">Medium</option>
						  <option value="High">High</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Market Risk Level
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Legal Counsel Review Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Legal Counsel Review Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["4"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_0_Change} className="form-control" name="Legal Counsel Review Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Review">In Review</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Needs Revision">Needs Revision</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Legal Counsel Review Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`DD Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1" type="text" className="form-control" placeholder="DD Report Link" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["4"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter DD Report Link`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Cleared For Pool`)} <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2_Change} 
					  checked={PREAUCT_PRE_AUCTION_DUE_DILIGENCE?.["4"]?.["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2"] === "true" || PREAUCT_PRE_AUCTION_DUE_DILIGENCE?.["4"]?.["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_4_2"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0" type="text" className="form-control" placeholder="Submitted By" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1" type="text" className="form-control" placeholder="Submitted At" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0"  value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1" type="text" className="form-control" placeholder="Created By" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2" type="text" className="form-control" placeholder="Created At" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3" type="text" className="form-control" placeholder="Updated By" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4" type="text" className="form-control" placeholder="Updated At" value={PREAUCT_PRE_AUCTION_DUE_DILIGENCE["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_PRE_AUCTION_DUE_DILIGENCE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREAUCT_Pre_Auction_Due_Diligence;  